import { render, staticRenderFns } from "./paIndexGroupList.vue?vue&type=template&id=4cfd7d1a&"
import script from "./paIndexGroupList.vue?vue&type=script&lang=js&"
export * from "./paIndexGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports